import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';

import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasThhPferdData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ThhPferdActions } from '../thhPferdActions';
import { IAppState } from '../appState';
import { buildTaasThhPferdDataForStrecke } from './transformer/thhPferdData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasThhPferdData>;

export function* streckenTarifierungThhPferd(): Generator<ForkEffect> {
  const requestActions = [
    TARIF_CHECKED,
    ZUSATZOPTION_CHECKED,
    ZUSATZOPTION_UNCHECKED,
    ThhPferdActions.PREISE_REQUESTED,
    ThhPferdActions.SELBSTBETEILIGUNG_CHANGED,
  ];
  const successActions = [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_PFERD,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_PFERD,
  ];

  streckenTarifierer = new StreckenTarifierer(
    {
      appId: App.THH_PFERD,
      successEventWithInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_THH_PFERD,
      successEventWithoutInfo:
        StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_THH_PFERD,
      errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_THH_PFERD,
    },
    buildTaasThhPferdDataForStrecke,
    undefined,
    createHashedRelevantRiskdataTHH,
  );

  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.THH_PFERD));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_THH_PFERD,
    safeSaga(streckenTarifierer.handleError, App.THH_PFERD),
  );
  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.THH_PFERD));
}

export function createHashedRelevantRiskdataTHH(taasData: TaasThhPferdData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;

  return createHashedTaasData(relevantData);
}
